import { render } from "./PromiseIcon1.vue?vue&type=template&id=306bbb5d"
import script from "./PromiseIcon1.vue?vue&type=script&lang=js"
export * from "./PromiseIcon1.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__